import { Component, effect, input, model, OnInit, output } from '@angular/core';
import { PaperSideType } from '../../../models/server-models/enums/paper-side-type';
import { PaperColorType } from '../../../models/server-models/enums/paper-color-type';
import { ExpandedPrintVariation } from '../../../models/client-models/entities/expanded-print-variation';
import { PrintVariationType } from '../../../models/server-models/enums/print-variation-type';
import { ExpandedPaperSize } from '../../../models/client-models/entities/expanded-paper-size';
import { ExpandedPaperType } from '../../../models/client-models/entities/expanded-paper-type';
import { PaperSizeType } from '../../../models/server-models/enums/paper-size-type';

@Component({
  selector: 'app-print-style-selection',
  templateUrl: './print-style-selection.component.html',
  styleUrls: ['./print-style-selection.component.scss'],
  standalone: false,
})
export class PaperSideSelectionComponent implements OnInit {
  paperSideType = PaperSideType;
  paperColorType = PaperColorType;

  selectedVariation = input.required<ExpandedPrintVariation | null>();
  selectedPaperSize = input.required<ExpandedPaperSize | null>();
  selectedPaperType = input.required<ExpandedPaperType | null>();

  selectedPaperSideType = model.required<PaperSideType | null>();
  selectedPaperColorType = model.required<PaperColorType | null>();

  doNextStep = output<void>();

  constructor() {
    // If the variation is certificate or business card, we need to set the paper side type to double sided
    // If the paper size is A1 or A2, we need to set the paper side type to single sided
    // If the paper type is glossy, we need to set the paper side type to single sided
    effect(() => {
      const type = this.selectedVariation()?.type;

      if (type == PrintVariationType.BusinessCard) {
        this.selectedPaperSideType.set(PaperSideType.DoubleSided);
      } else if (!this.shouldShowPaperColorSide()) {
        this.selectedPaperSideType.set(PaperSideType.SingleSided);
      }
    });
  }

  ngOnInit() {}

  onPaperSideClick(side: PaperSideType) {
    this.selectedPaperSideType.set(side);
  }

  onPaperColorTypeClick(colorType: PaperColorType) {
    this.selectedPaperColorType.set(colorType);
  }

  // If the variation is image, certificate or business card, we don't need to show the paper color side
  // If the paper size is A1 or A2, we don't need to show the paper color side
  // If the paper type is glossy or sticker, we don't need to show the paper color side
  shouldShowPaperColorSide() {
    const type = this.selectedVariation()?.type;

    if (
      type == PrintVariationType.Image ||
      type == PrintVariationType.Certificate ||
      type == PrintVariationType.BusinessCard
    ) {
      return false;
    }

    if (this.selectedPaperSize()?.type == PaperSizeType.A1 || this.selectedPaperSize()?.type == PaperSizeType.A2) {
      return false;
    }

    if (this.selectedPaperType()?.name.en.toLowerCase().includes('glossy')) {
      return false;
    }

    if (this.selectedPaperType()?.name.en.toLowerCase().includes('sticker')) {
      return false;
    }

    return true;
  }

  onDoubleClick() {
    this.doNextStep.emit();
  }
}
